import type { PageContext } from "vike/types";
import { matchSearchIndexPath } from "./match-search-index-path";

export function route(pageContext: PageContext) {
  const raw = pageContext.urlPathname;
  const path = raw !== "/" ? raw.replace(/\/$/, "") : raw;
  return matchSearchIndexPath(path);
}
